import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import LoginPage from '@/pages/LoginPage';
import Dashboard from '@/pages/Dashboard';
import CandidateLanding from '@/pages/CandidateLanding';
import CandidateAssessment from '@/pages/CandidateAssessment';
import ReportView from '@/pages/ReportView';
import ThankYou from '@/pages/ThankYou';
import UserManagement from '@/pages/UserManagement';
import Settings from '@/pages/Settings';
import AuditLogs from '@/pages/AuditLogs';
import CandidateCompare from '@/pages/CandidateCompare';
import AuthCallback from '@/pages/AuthCallback';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import { Toaster } from 'sonner';
import { api } from '@/utils/api';
import { applyBrandColor } from '@/lib/theme';

function App() {
  // The organisation's colour, applied to every page including the public
  // candidate ones. Best effort: if it fails the default palette stays.
  useEffect(() => {
    api.getBranding()
      .then((res) => applyBrandColor(res.data?.primary_color))
      .catch(() => {});
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/assess/:token" element={<CandidateLanding />} />
          <Route path="/assess/:token/start" element={<CandidateAssessment />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/report/:assessmentId" element={<ProtectedRoute><ReportView /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute requireAdmin><UserManagement /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute requireAdmin><Settings /></ProtectedRoute>} />
          <Route path="/admin/audit" element={<ProtectedRoute requireAdmin><AuditLogs /></ProtectedRoute>} />
          <Route path="/compare" element={<ProtectedRoute><CandidateCompare /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
